export default "__VITE_ASSET__CZXYJxX8__"